'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 *
 */
var REMOTE_CREATE = exports.REMOTE_CREATE = 'vtech-chat/messages/REMOTE_CREATE';
var REMOTE_CREATE_SUCCESS = exports.REMOTE_CREATE_SUCCESS = 'vtech-chat/messages/REMOTE_CREATE_SUCCESS';
var ADD = exports.ADD = 'vtech-chat/messages/ADD';
var LOAD_MESSAGES = exports.LOAD_MESSAGES = 'vtech-chat/messages/LOAD_MESSAGES';
var INITIALIZE = exports.INITIALIZE = 'vtech-chat/messages/INITIALIZE';

/**
 *	Creates a message on the server.
 */
var remoteCreate = exports.remoteCreate = function remoteCreate(discussionId, author, text) {
	return {
		type: REMOTE_CREATE,
		meta: {
			discussionId: discussionId
		},
		payload: {
			author: author,
			text: text
		}
	};
};

/**
 *	Load initial messages from the server.
 */
var loadMessages = exports.loadMessages = function loadMessages(discussionId) {
	return {
		type: LOAD_MESSAGES,
		meta: {
			discussionId: discussionId
		}
	};
};

/**
 *	Acknowledges a successful creation.
 */
var remoteCreateSuccess = exports.remoteCreateSuccess = function remoteCreateSuccess(discussionId, message) {
	return {
		type: REMOTE_CREATE_SUCCESS,
		meta: {
			discussionId: discussionId
		},
		payload: {
			message: message
		}
	};
};

/**
 *	Adds a or several messages to the store.
 */
var add = exports.add = function add(discussionId, messagesList) {
	return {
		type: ADD,
		meta: {
			discussionId: discussionId
		},
		payload: {
			discussionId: discussionId,
			messagesList: messagesList
		}
	};
};

/**
 *	Initialize store with history messages.
 */
var initialize = exports.initialize = function initialize(discussionId, messagesList) {
	return {
		type: INITIALIZE,
		payload: {
			discussionId: discussionId,
			messagesList: messagesList
		}
	};
};